var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgShieldCheck = function SvgShieldCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.509 14.114c-.207.134-.381.24-.509.313a13 13 0 0 1-2.163-1.585C4.619 11.735 3.5 10.236 3.5 8.5V4.292L8 2.537l4.5 1.755V8.5c0 1.735-1.119 3.234-2.336 4.343-.6.546-1.202.976-1.655 1.27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.39 7.688a.5.5 0 1 0-.78.624zM7.6 10l-.39.312a.5.5 0 0 0 .78 0zm2.79-2.688a.5.5 0 1 0-.78-.624zm-4.78 1 1.6 2 .78-.624-1.6-2zm2.38 2 2.4-3-.78-.624-2.4 3z"
  })));
};
var Memo = /*#__PURE__*/memo(SvgShieldCheck);
export default Memo;